<template>
  <div :style="wrapperStyle">
    <label v-if="fieldLabel" class="form-field-label" :for="uniqueTitle">{{ fieldLabel }}</label>
    <b-form-input
      :id="uniqueTitle"
      :name="uniqueTitle"
      :model-value="shownValue"
      :placeholder="placeholder || undefined"
      :readonly="isReadonly"
      :aria-describedby="describedBy"
      :class="{ 'form-field-readonly': isReadonly }"
      @update:model-value="onInput"
      @input="onInput"
    />
  </div>
</template>

<script>
import { inject, computed } from 'vue'
import { formattingToStyle } from '../../lib/client-rule-evaluator'
import { fieldValue, inputEventValue } from './form-controls'

export default {
  props: ['placeholder', 'uniqueTitle', 'fieldLabel', 'description'],
  setup (props) {

    const formFormatting = inject('formFormatting', null)
    const formReadonly = inject('formReadonly', null)
    const formValues = inject('formValues', null)
    const updateFormValue = inject('updateFormValue', null)

    const wrapperStyle = computed(() => {
      if (!formFormatting || !props.uniqueTitle) return {}
      const fmt = formFormatting[props.uniqueTitle]
      return fmt ? formattingToStyle(fmt) : {}
    })

    const isReadonly = computed(() => {
      if (!formReadonly || !props.uniqueTitle) return false
      return !!formReadonly[props.uniqueTitle]
    })

    const describedBy = computed(() => {
      return props.description ? `${props.uniqueTitle}-description` : undefined
    })

    const shownValue = computed(() => fieldValue(formValues, props.uniqueTitle))

    return { formFormatting, formReadonly, updateFormValue, wrapperStyle, isReadonly, describedBy, shownValue }
  },
  methods: {
    onInput (value) {
      if (this.updateFormValue) {
        this.updateFormValue(this.uniqueTitle, inputEventValue(value))
      }
    }
  }
}
</script>

<style>
.form-field-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  text-align: left;
}
</style>
